import React from 'react'
import {
    Alert,
    Box,
    Card,
    CardContent,
    Grid,
    IconButton,
    Stack,
    Tooltip,
} from '@mui/material'
import { useFieldArray, UseFormReturn } from 'react-hook-form'
import DeleteIcon from '@mui/icons-material/Delete'

import { FormOperacionLCLS } from '../types/types'
import { OperacionLCLSCuentaFields, OperacionLCLSFields } from '../types/fields'
import { useConfirmationDialog } from 'src/hooks/useConfirmationDialog'
import CardActions from 'src/pages/sistema/components/CardActions'
import { FieldView } from 'src/pages/sistema/components/FieldView'
import { ControlledTextField } from 'src/components/forms'
import { useLoadOptions } from 'src/hooks/useLoadOptions'
import { useLCLSLimiteTipos } from '../hooks/useLCLSCache'
import { OperacionLCLSCampoLimite } from './OperacionLCLSCampoLimite'

interface SeccionNuevoLCLSCuentasProps {
    formMethods: UseFormReturn<FormOperacionLCLS>
}

export const SeccionNuevoLCLSCuentas = ({
    formMethods: mainFormMethods,
}: SeccionNuevoLCLSCuentasProps) => {
    const {fields, append, remove} = useFieldArray({
        control: mainFormMethods.control,
        name: OperacionLCLSFields.Cuentas
    });

    const {askConfirmation} = useConfirmationDialog()

    const limitesTipos = useLCLSLimiteTipos();
    const loadLimites = useLoadOptions({
        data: limitesTipos.limiteTipos,
        loading: limitesTipos.isLoading,
        isError: limitesTipos.isError,
        error: limitesTipos.error
    });

    return (
        <CardActions
            title={'Cuentas'}
            icon='mdi:account-cash-outline'
            colapsable
        >
            {fields.length === 0 ? (
                <Alert severity='info'>Seleccione una Unidad de Negocio y un Sector Comercial para ver las cuentas.</Alert>
            ) : (
                <Stack spacing={3}>
                    {fields.map((cuenta, index) => {
                        const { control, getValues } = mainFormMethods;
                        const cuentaData = getValues(`cuentas.${index}`);

                        return (
                            <Card key={cuenta.id} variant="outlined" sx={{boxShadow: 1}}>
                                <Box display='flex' justifyContent='flex-end' sx={{pt: 1, pr: 1}}>
                                    <Tooltip title="Eliminar Cuenta">
                                        <IconButton size="small"
                                            onClick={() => askConfirmation(() => remove(index))}>
                                            <DeleteIcon color="error"/>
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <CardContent sx={{pt: 0}}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FieldView label='Tipo Cliente' value={cuentaData[OperacionLCLSCuentaFields.DescClienteTipo]} />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FieldView label='Sub-tipo' value={cuentaData[OperacionLCLSCuentaFields.DescClienteSubTipo]} />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <ControlledTextField
                                                control={control}
                                                name={`cuentas.${index}.${OperacionLCLSCuentaFields.NroCuenta}`}
                                                label='Número de cuenta'
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <ControlledTextField
                                                control={control}
                                                name={`cuentas.${index}.${OperacionLCLSCuentaFields.RazonSocial}`}
                                                label='Razón Social'
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <ControlledTextField
                                                control={control}
                                                name={`cuentas.${index}.${OperacionLCLSCuentaFields.Moneda}`}
                                                label='Moneda'
                                                disabled
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <OperacionLCLSCampoLimite
                                                control={control}
                                                name={`cuentas.${index}.${OperacionLCLSCuentaFields.LimiteConcertacion}`}
                                                label='Límite Concertación'
                                                loadOptions={loadLimites}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <OperacionLCLSCampoLimite
                                                control={control}
                                                name={`cuentas.${index}.${OperacionLCLSCuentaFields.LimiteLiquidacionDVP}`}
                                                label='Límite DVP'
                                                loadOptions={loadLimites}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <OperacionLCLSCampoLimite
                                                control={control}
                                                name={`cuentas.${index}.${OperacionLCLSCuentaFields.LimiteLiquidacionFOP}`}
                                                label='Límite FOP'
                                                loadOptions={loadLimites}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        )
                    })}
                </Stack>
            )}
        </CardActions>
    )
}